import React from "react";

const LoadingSpinner = () => {
    return (
        <div className='spinner-container'>
            <div className='px-4 py-3'>
                <div className="spinner-border sd-spinner" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    )
}

export default LoadingSpinner;
